import { FC } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';

interface Props {
  onNext: () => void;
}

interface ForgotPasswordForm {
  email: string;
}

const ForgotPassword: FC<Props> = ({ onNext }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordForm>();

  const onSubmit: SubmitHandler<ForgotPasswordForm> = (data) => {
    console.log('Sending OTP to:', data.email);
    // Call API here
    onNext();
  };

  return (
    <div className="auth-container">
      <h2>wizkind</h2>
      <p className="font-semibold">Reset Your Password</p>
      <p>Please enter your email address to receive a verification code.</p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          {...register('email', { required: 'Email is required' })}
          placeholder="Email Address"
          className="input"
        />
        {errors.email && <p className="error-text">{errors.email.message}</p>}

        <button type="submit" className="btn-primary">Continue</button>
      </form>
    </div>
  );
};

export default ForgotPassword;
